import React, { Component } from 'react';
import ReportPage from './ReportPage';
import QuartileChart from '../QuartileChart';
import RankTable from '../RankTable';

export default class RankGraphPage extends Component {
    render() {
        return (
            <ReportPage {...this.props} title="TDF Rankings" subtitle="Target-Date Blueprint has ranked the relative suitability of more than 40 TDF based on your plan’s unique risk profile. Those in Quartile 1 represent those that most closely match the plan’s objectives and risk profile. Those in lower quartiles are less aligned with plan objectives." className="rank-graph" pageNumber={this.props.pageNumber}>
                <div className="mt-5">
                    {this.props.quartiles ? <div className="mt-4"><RankTable {...this.props}/></div> : <QuartileChart isPrint={true} />}
                    <small className="d-block mt-4 text-center footnotes">
                        When American Century is noted,  this includes American Century One Choice Portfolios, American Century Retirement Date Hybrid Trust and American Century Retirement Readiness Trust.
                    </small>
                </div>
            </ReportPage>
        );
    }
}
